const STROKE = "1.5";

function Tennis() {
	return (
		<svg viewBox="0 0 100 60" fill="none" stroke="currentColor" strokeWidth={STROKE}>
			<rect x="4" y="4" width="92" height="52" />
			<line x1="50" y1="4" x2="50" y2="56" />
			<line x1="20" y1="4" x2="20" y2="56" opacity="0.5" />
			<line x1="80" y1="4" x2="80" y2="56" opacity="0.5" />
			<line x1="20" y1="30" x2="80" y2="30" opacity="0.5" />
		</svg>
	);
}

function Padel() {
	return (
		<svg viewBox="0 0 100 60" fill="none" stroke="currentColor" strokeWidth={STROKE}>
			<rect x="4" y="4" width="92" height="52" />
			<rect x="8" y="8" width="84" height="44" opacity="0.5" />
			<line x1="50" y1="4" x2="50" y2="56" />
		</svg>
	);
}

function Badminton() {
	return (
		<svg viewBox="0 0 100 60" fill="none" stroke="currentColor" strokeWidth={STROKE}>
			<rect x="4" y="4" width="92" height="52" />
			<line x1="50" y1="4" x2="50" y2="56" strokeWidth="2.5" />
			<line x1="36" y1="4" x2="36" y2="56" opacity="0.5" />
			<line x1="64" y1="4" x2="64" y2="56" opacity="0.5" />
		</svg>
	);
}

function Pickleball() {
	return (
		<svg viewBox="0 0 100 60" fill="none" stroke="currentColor" strokeWidth={STROKE}>
			<rect x="4" y="4" width="92" height="52" />
			<line x1="50" y1="4" x2="50" y2="56" strokeWidth="2.5" />
			<line x1="32" y1="4" x2="32" y2="56" opacity="0.5" />
			<line x1="68" y1="4" x2="68" y2="56" opacity="0.5" />
		</svg>
	);
}

function PingPong() {
	return (
		<svg viewBox="0 0 100 60" fill="none" stroke="currentColor" strokeWidth={STROKE}>
			<rect x="4" y="14" width="92" height="32" />
			<line x1="50" y1="6" x2="50" y2="54" strokeWidth="2.5" />
			<line x1="4" y1="30" x2="96" y2="30" opacity="0.5" />
		</svg>
	);
}

function Squash() {
	return (
		<svg viewBox="0 0 100 60" fill="none" stroke="currentColor" strokeWidth={STROKE}>
			<rect x="4" y="4" width="92" height="52" />
			<line x1="4" y1="22" x2="96" y2="22" opacity="0.6" />
			<line x1="50" y1="22" x2="50" y2="56" opacity="0.5" />
			<line x1="4" y1="46" x2="96" y2="46" opacity="0.5" />
		</svg>
	);
}

const ICONS = {
	Tennis,
	Padel,
	Badminton,
	Pickleball,
	"Ping Pong": PingPong,
	Squash,
};

export default function CourtIcon({ sport }) {
	const Icon = ICONS[sport] || Tennis;
	return <Icon />;
}
